import { createIcon } from '@chakra-ui/icon'

export const AccountIcon = createIcon({
  displayName: 'AccountSmallIcon',
  viewBox: '0 0 24 24',
  path: (
    <g
      fill="none"
      stroke="currentColor"
      strokeDasharray="20"
      strokeDashoffset="20"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="M6 19v-1c0 -2.21 1.79 -4 4 -4h4c2.21 0 4 1.79 4 4v1">
        <animate
          fill="freeze"
          attributeName="stroke-dashoffset"
          dur="0.2s"
          values="20;0"
        />
      </path>
      <path d="M12 11c-1.66 0 -3 -1.34 -3 -3c0 -1.66 1.34 -3 3 -3c1.66 0 3 1.34 3 3c0 1.66 -1.34 3 -3 3Z">
        <animate
          fill="freeze"
          attributeName="stroke-dashoffset"
          begin="0.2s"
          dur="0.2s"
          values="20;0"
        />
      </path>
    </g>
  ),
})
